import React, { Component } from 'react';

import "./CreditChecklist.scss"

class CreditChecklist extends Component {
    render() {
        return (
            <div className="box">
                <div className="check"></div>
                <div className="text" dangerouslySetInnerHTML={{ __html: this.props.item.name }}></div>
            </div>
        );
    }
}

export default CreditChecklist;



// WEBPACK FOOTER //
// ./src/components/Creditor/components/CreditChecklist/CreditChecklist.js